import type { Stream } from "@zoom/videosdk";
import { deviceIsIOS } from "../../../../../utils";
import { LocalAudioDelegator } from "../../../../core/room/participant/media/MediaDelegator";
import { getStoredAudioVideoSettings } from "../../../../core/utils";
import { audioStreams } from "../../../utils/interceptUserMedia";

export class ZoomLocalAudioDelegator implements LocalAudioDelegator {
  readonly kind = "audio" as const;
  #stream: typeof Stream;

  constructor(stream: typeof Stream) {
    this.#stream = stream;
  }

  get deviceId() {
    return this.#stream.getActiveMicrophone();
  }

  get isEnabled() {
    return !!this.#stream;
  }

  /**
   * Get the MediaStream from the intercepted streams.
   * Returns the stream with audio tracks matching the stored device settings.
   */
  get mediaStream() {
    const { inputAudioDeviceId } = getStoredAudioVideoSettings();

    const mediaStream = audioStreams.find((mediaStream) => {
      const audioTrack = mediaStream.getAudioTracks()?.[0];
      if (audioTrack?.readyState !== "live") {
        return false;
      }

      if (inputAudioDeviceId) {
        const trackDeviceId = audioTrack.getSettings().deviceId;
        return trackDeviceId === inputAudioDeviceId;
      }

      return true;
    });

    return deviceIsIOS() ? mediaStream?.clone() : mediaStream;
  }
}
